const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}


// YSS pointer aura
(function yssPointerAura(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var currentX = window.innerWidth * 0.5;
  var currentY = window.innerHeight * 0.3;
  var targetX = currentX;
  var targetY = currentY;
  var root = document.documentElement;
  function setTarget(e){ targetX = e.clientX; targetY = e.clientY; }
  function tick(){
    currentX += (targetX - currentX) * 0.08;
    currentY += (targetY - currentY) * 0.08;
    root.style.setProperty('--yss-mx', currentX + 'px');
    root.style.setProperty('--yss-my', currentY + 'px');
    requestAnimationFrame(tick);
  }
  window.addEventListener('mousemove', setTarget, { passive: true });
  window.addEventListener('touchmove', function(e){
    if (e.touches && e.touches[0]) { targetX = e.touches[0].clientX; targetY = e.touches[0].clientY; }
  }, { passive: true });
  requestAnimationFrame(tick);
})();


// YSS floating particles
(function yssFloatingParticles(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.getElementById('yss-particles')) return;
  var wrap = document.createElement('div');
  wrap.id = 'yss-particles';
  document.body.appendChild(wrap);
  var count = window.innerWidth < 768 ? 18 : 34;
  function build(){
    wrap.innerHTML = '';
    for (var i=0;i<count;i++){
      var p = document.createElement('span');
      p.className = 'yss-particle';
      var size = Math.random() * 6 + 2;
      var left = Math.random() * 100;
      var top = Math.random() * 100;
      var dx = (Math.random() * 160 - 80).toFixed(0) + 'px';
      var dy = (Math.random() * 180 + 120).toFixed(0) + 'px';
      var dur = (Math.random() * 14 + 10).toFixed(2) + 's';
      var delay = (-Math.random() * 18).toFixed(2) + 's';
      p.style.width = size + 'px';
      p.style.height = size + 'px';
      p.style.left = left + '%';
      p.style.top = top + '%';
      p.style.setProperty('--dx', dx);
      p.style.setProperty('--dy', dy);
      p.style.animationDuration = dur;
      p.style.animationDelay = delay;
      p.style.opacity = (Math.random() * 0.45 + 0.18).toFixed(2);
      wrap.appendChild(p);
    }
  }
  build();
  window.addEventListener('resize', function(){
    count = window.innerWidth < 768 ? 18 : 34;
    build();
  });
})();
